import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { IVariant } from '../../../models/products.models';

@Component({
  selector: 'app-edit-variant-product-settings',
  templateUrl: './edit-variant-product-settings.component.html',
  styleUrls: ['./edit-variant-product-settings.component.scss']
})
export class EditVariantProductSettingsComponent implements OnInit {

  form!: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<EditVariantProductSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private translate: TranslateService,
  ) {
    this.form = this.fb.group({});
  }

  ngOnInit(): void {
    this.data.variants.forEach((variant: IVariant) => {
      this.form.addControl(`reorder_point_${variant.id}`, new FormControl(variant.stock?.reorder_point ?? null, []));
      this.form.addControl(`can_be_sold_out_of_stock_${variant.id}`, new FormControl(variant.can_be_sold_out_of_stock ?? false, []));
      this.form.addControl(`increment_${variant.id}`, new FormControl(variant.increment ?? 1, []));
      this.form.addControl(`max_qte_${variant.id}`, new FormControl(variant.max_qte ?? null, []));
      this.form.addControl(`min_qte_${variant.id}`, new FormControl(variant.min_qte ?? 1, []));
    });
  }

  sanitize(event: any) {
    event.target.value = event.target.value.replace(/[^\d]/g, '');
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const variants: IVariant[] = this.data.variants.map((variant: IVariant) => {
        return {
          ...variant,
          values: undefined,
          code_identifiers: undefined,
          codes: undefined,
          image: undefined,
          can_be_sold_out_of_stock: this.form.get(`can_be_sold_out_of_stock_${variant.id}`)?.value,
          increment: this.form.get(`increment_${variant.id}`)?.value,
          max_qte: this.form.get(`max_qte_${variant.id}`)?.value,
          min_qte: this.form.get(`min_qte_${variant.id}`)?.value,
          stock: {
            ...variant.stock,
            reorder_point: this.form.get(`reorder_point_${variant.id}`)?.value,
          },
        };
      });
    this.dialogRef.close(variants);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
